import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { ILanguage } from '@web/dtos';

@Pipe({
  name: 'langToOptions',
  standalone: true,
})
@Injectable({
  providedIn: 'root',
})
export class LangToOptionsPipe implements PipeTransform {
  transform(langs: ILanguage[]): { value: string; name: string }[] {
    return langs
      .filter((lang: ILanguage) => lang.isActive)
      .map((lang: ILanguage) => {
        return { value: lang.id!, name: `${lang.name} (${lang.prefix})` };
      });
  }
}
